
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cursos/[slug]",
      function () {
        return require("private-next-pages/cursos/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cursos/[slug]"])
      });
    }
  